import { render } from "./ReportesPage.vue?vue&type=template&id=0f55e242&scoped=true"
import script from "./ReportesPage.vue?vue&type=script&lang=js"
export * from "./ReportesPage.vue?vue&type=script&lang=js"

import "./ReportesPage.vue?vue&type=style&index=0&id=0f55e242&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f55e242"]])

export default __exports__